<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<app-navbar-component></app-navbar-component>
<div>
  <br />
  <br />
  <div *ngFor="let data of checkout">
    <h1>
      <p>
        <i class="fa fa-check-circle data-show" style="font-size:48px;color:#20AF93"></i>
        You are about to checkout patient {{ data.pat_name }} !
      </p>
    </h1>
    <br />
    <h2>
      {{ data.date | date: "dd-MM-yyyy" }} at {{ today | date: "hh:mm a " }}
    </h2>
  </div>

  <button class="checkout" type="submit" (click)="statuscheck()" (click)="back()">
    Confirm Checkout
  </button>
</div>